import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';
import {screenResizeStore} from '../../global/store/screen-resize-store';
import {isProductDesktopViewport} from './viewport/viewport';
import {getProductTitleSizeClass} from './product-header-title';
import {productHeadingText} from './product-heading';
import PricingStatus from './pricing-status';
import {getPriceDisplay} from '../pricing-request/price-display';

declare var _is_caf: boolean;
declare var _msrp_red: boolean;

const ProductHeader: React.FC = observer(() => {
    const goReviews = useCallback(() => {
        const d = document.getElementById('prod-reviews') as HTMLDivElement;
        const panel = document.getElementById('yotpo-main');
        // The header toggles. Open a closed section, and leave an open one open.
        if (panel && !panel.classList.contains('show')) {
            document.getElementById('prod-reviews-click')?.click();
        }
        setTimeout(function () {
            if (d) {
                d.scrollIntoView();
            }
        }, 100);
    }, []);

    const isDesktopViewport = isProductDesktopViewport(screenResizeStore.width);

    if (!s.si) return null;

    // The server's heading when the page carries one (the shell showed it before mount), else the app's own formula.
    const headingText = productHeadingText();
    const titleClass = getProductTitleSizeClass(headingText);
    const priceDisplay = getPriceDisplay(s.ui);

    return (
        <div id="prod-header">
            <div style={{maxWidth: '75%'}}>
                {s.prod && s.si && <h1 className={titleClass}>{headingText}</h1>}

                <div id="prod-sub-titles">
                    {!util.isNullOrWhiteSpace(s.ui.sku) && <span className="sku">SKU: {s.ui.sku}</span>}
                    {!s.ps.is_caf && <span className="item-id">Item #: {s.ui.item_id.replace('215873-', 'P').replace('220395-', 'P')}</span>}

                    {s.ui.allow_reviews && s.ui.review_count > 0 && (
                        <div id="yotpo-prod-header">
                            <a
                                href="#reviews"
                                onClick={e => {
                                    e.preventDefault();
                                    goReviews();
                                }}
                            >
                                <div className="prod-yotpo-stars">
                                    {Number.isFinite(s.ui.review_score) && <span className="sr-only">Rated {String(Math.round(s.ui.review_score * 10) / 10)} out of 5. </span>}
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 0 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 1 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 2 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 3 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 4 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span className="yotpo-star-count">({s.ui.review_count})</span>
                                </div>
                            </a>
                        </div>
                    )}
                </div>
            </div>

            <div
                className="hide-sm"
                aria-busy={s.ui.pricing_loading}
            >
                {isDesktopViewport && s.ui.show_pricing && priceDisplay.hasDiscount && (
                    <div>
                        <span className={_msrp_red ? `msrp-disc msrp-red` : `msrp-disc`}>
                            <span className="sr-only">Sale price </span>
                            {priceDisplay.current}
                        </span>
                        <span className={`msrp-orig`}>
                            <span className="sr-only">Regular price </span>
                            <del>{priceDisplay.original}</del>
                        </span>
                    </div>
                )}
                {isDesktopViewport && s.ui.show_pricing && !priceDisplay.hasDiscount && (
                    <div>
                        <span className={`msrp-disc`}>{priceDisplay.current}</span>
                    </div>
                )}
                {isDesktopViewport && s.ui.show_pricing && <PricingStatus error={s.ui.pricing_error} />}
            </div>
        </div>
    );
});

export default ProductHeader;
